import { render, staticRenderFns } from "./CompProfileEditSkeleton.vue?vue&type=template&id=eb01a3bc&scoped=true"
import script from "./CompProfileEditSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileEditSkeleton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb01a3bc",
  null
  
)

export default component.exports